import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormCheckbox, FormInput } from "components/BaseForm";
import CaseDomainService from "services/CaseDomain";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  computer_domain: z.boolean(),
  email_domain: z.boolean(),
});

function CaseDomainForm({ model, onSuccess }) {
  const handleSubmit = async values => {
    const data = {
      name: values.name,
      computer_domain: values.computer_domain,
      email_domain: values.email_domain,
    };
    if (model?.id) {
      await CaseDomainService.edit(model.id, data);
    } else {
      await CaseDomainService.create(data);
    }
    toast.success("Case Domain saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: model?.name ?? "",
        computer_domain: model?.computer_domain ?? true,
        email_domain: model?.email_domain ?? true,
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required autoFocus />
      <FormCheckbox name="computer_domain" label="Computer Domain" />
      <FormCheckbox name="email_domain" label="Email Domain" />
    </BaseForm>
  );
}

export default CaseDomainForm;
